export const headerHeight = 64
export const headerHeightTablet = 64
export const headerHeightFull = 84
